import { render } from "./RadarMIRA35C.vue?vue&type=template&id=60001f12"
import script from "./RadarMIRA35C.vue?vue&type=script&lang=js"
export * from "./RadarMIRA35C.vue?vue&type=script&lang=js"

import exportComponent from "/proyectos/programas-de-investigacion/cah-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__